import { service } from '../axios';
export function saveConsPurchaseOrder(data) {
    return service({
        url: '/cons/purchase/save',
        method: 'post',
        data,
    });
}
export function getConsPurchaseOderAndDetail(params) {
    return service({
        url: '/cons/purchase/getDetail',
        method: 'get',
        params
    });
}
export function getConsPurchaseWaitInItemsPage(params) {
    return service({
        url: '/cons/purchase/getInItemsPage',
        method: 'get',
        params
    });
}
export function getConsPurchaseWaitInItemsByItemIds(params) {
    return service({
        url: '/cons/purchase/getInItemsByItemIds',
        method: 'get',
        params
    });
}
/*创建耗材入库打印任务*/
export function createConsInPrintTask(data) {
    return service({
        url: '/print-task/cons-in', // 对应后台接口
        method: 'post',
        data
    });
}
